export default {
  computed: {
    trashEmail: {
      get () {
        return this.$store.getters.trashEmail
      },
      set (data) {
        this.$store.dispatch('setTrashEmail', data)
      }
    },
    sentEmail: {
      get () {
        return this.$store.getters.sentEmail
      },
      set (data) {
        this.$store.dispatch('setSentEmail', data)
      }
    },
    draftEmail: {
      get () {
        return this.$store.getters.draftEmail
      },
      set (data) {
        this.$store.dispatch('setDraftEmail', data)
      }
    },
    inboxEmail: {
      get () {
        return this.$store.getters.inboxEmail
      },
      set (data) {
        this.$store.dispatch('setInboxEmail', data)
      }
    },
    todoEmail: {
      get () {
        return this.$store.getters.todoEmail
      },
      set (data) {
        this.$store.dispatch('setTodoEmail', data)
      }
    },
    savedEmail: {
      get () {
        return this.$store.getters.savedEmail
      },
      set (data) {
        this.$store.dispatch('setSavedEmail', data)
      }
    }
  },
  methods: {
    resetEmailsStore () {
      this.trashEmail = []
      this.sentEmail = []
      this.draftEmail = []
      this.inboxEmail = []
      this.todoEmail = []
      this.savedEmail = []
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/resetEmailsStore.js